import { ReactElement } from "react";
import { Control, ControllerProps } from "react-hook-form";

import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/_atoms/form";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@/components/_atoms/select";
import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";
import { MunicipalPropertyCreateFormValues } from "@/domain/municipal-property/models/municipal-property-create-form-values";
import { WorkspaceMunicipalityOption } from "@/domain/municipal-property/models/workspace-municipality-option.model";
const UNASSIGNED_MUNICIPALITY: string = "unassigned";
interface MunicipalPropertyMunicipalityFieldsetProps {
  control: Control<MunicipalPropertyCreateFormValues>;
  municipalityList: readonly WorkspaceMunicipalityOption[];
}
export function MunicipalPropertyMunicipalityFieldset({
  control,
  municipalityList,
}: MunicipalPropertyMunicipalityFieldsetProps): ReactElement {
  const { t }: ReturnType<typeof useDomainTranslation> = useDomainTranslation("municipal-property");
  return (
    <fieldset className="flex flex-col gap-3">
      <legend className="text-sm font-medium">{t("create.section.eligibility")}</legend>
      <FormField
        control={control}
        name="municipalityIdList"
        render={({
          field,
        }: Parameters<
          ControllerProps<MunicipalPropertyCreateFormValues, "municipalityIdList">["render"]
        >[0]): ReactElement => (
          <FormItem>
            <FormLabel>{t("create.field.municipalityList")}</FormLabel>
            <Select
              value={field.value[0] ?? UNASSIGNED_MUNICIPALITY}
              onValueChange={(municipalityId: string): void =>
                field.onChange(municipalityId === UNASSIGNED_MUNICIPALITY ? [] : [municipalityId])
              }
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectGroup>
                  <SelectItem value={UNASSIGNED_MUNICIPALITY}>{t("municipalitySelect.workspaceWide")}</SelectItem>
                  {municipalityList.map(
                    (municipality: WorkspaceMunicipalityOption): ReactElement => (
                      <SelectItem key={municipality.id} value={municipality.id}>
                        {municipality.name}
                      </SelectItem>
                    ),
                  )}
                </SelectGroup>
              </SelectContent>
            </Select>
            <FormDescription>{t("create.field.municipalityListHint")}</FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </fieldset>
  );
}
